export default "6142e3565eaefb5d.svg"